<div class="viewer-dialog" *ngIf="!isLoading && current">
  <!-- Header -->
  <div class="dialog-header">
    <span class="tag-chip">{{ 'announcements.viewer.newAnnouncement' | translate }}</span>
    <div class="nav-counter" *ngIf="totalCount > 1">
      <span>{{ currentIndex + 1 }} of {{ totalCount }}</span>
      <button class="nav-chevron" (click)="navigateNext()" [disabled]="!hasNext">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>

  <!-- Body -->
  <div class="dialog-body">
    <div class="title-row">
      <h3 class="announcement-title">{{ current.title }}</h3>
      <mat-icon *ngIf="current.priority === 'critical'" class="critical-icon">error</mat-icon>
    </div>

    <p class="announcement-message">{{ current.message }}</p>

    <div class="duration-section">
      <span class="duration-label">{{ 'announcements.viewer.validDuration' | translate }}</span>
      <span class="duration-value">
        {{ current.displayFrom | date:'dd MMM yyyy' }} – {{ current.displayTo | date:'dd MMM yyyy' }}
      </span>
    </div>

    <div class="attachment-section" *ngIf="current.attachmentKey">
      <span class="attachment-label">{{ 'announcements.viewer.attachment' | translate }}</span>
      <div class="attachment-pill" (click)="downloadAttachment()">
        <mat-icon class="attach-icon">picture_as_pdf</mat-icon>
        <span class="attach-name">{{ current.attachmentName || 'Document.pdf' }}</span>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <button class="btn-close" (click)="close()">
      {{ 'announcements.viewer.close' | translate }}
    </button>
    <button
      class="btn-acknowledge"
      (click)="acknowledge()"
      [disabled]="isAcknowledging"
    >
      {{ 'announcements.viewer.acknowledge' | translate }}
    </button>
  </div>
</div>

<div class="viewer-dialog loading-state" *ngIf="isLoading">
  <p>{{ 'common.loading' | translate }}</p>
</div>
